import { useState } from 'react';

/**
 * A wrapper over useState for boolean only states which can be set on or off.
 * ```
 * const [isPopupOpen, showPopup, hidePopup, toggleIsPopupOpen] = useToggleState(false);
 * ```
 */
var useToggleState = function (initialState) {
    var _a = useState(initialState !== null && initialState !== void 0 ? initialState : false), state = _a[0], setState = _a[1];
    var setTrue = function () { return setState(true); };
    var setFalse = function () { return setState(false); };
    var toggle = function () { return setState(function (prevState) { return !prevState; }); };
    return [state, setTrue, setFalse, toggle];
};

export { useToggleState };
//# sourceMappingURL=boolean.js.map
